import type { PageHelpContent } from './types';

export const familiesHelp: PageHelpContent = {
  pageGuide: {
    title: 'Как работают семьи пациентов',
    body: [
      'Семьи объединяют пациентов одного домохозяйства для семейных программ и скидок.',
      'Создавайте семьи вручную или используйте вкладку «Потенциальные семьи» — система автоматически находит возможные совпадения.',
    ],
  },
  expandedGuide: {
    title: '',
    body: [
      'Система определяет потенциальные семьи по совпадению фамилий, адресов и связей между записями.',
      'Вы можете подтвердить или отклонить предложенные совпадения — решение всегда за вами.',
      'Каждая семья содержит список участников с указанием роли (глава семьи, член семьи).',
    ],
  },
  tooltips: {
    potential_families: 'Система анализирует данные пациентов и предлагает возможные семейные группы на основе совпадений фамилий и адресов.',
    create_family: 'Создать новую семью вручную — добавьте участников по номеру телефона или имени.',
    family_card: 'Карточка семьи. Содержит участников, их контакты и общую информацию по семье.',
  },
};
